import React from 'react';
import {
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaGoogle,
  FaInstagram
} from 'react-icons/fa';

function Footer() {
  return (
    <footer className="bg-[#40858a] text-white  ">
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-2 gap-8 text-center md:justify-center md:text-left">
        <div>
          <h3 className="font-bold text-lg mb-4">
            TravChap by Safarnaama Holidays{' '}
          </h3>
          <p>
            S2S Complex, 1st Floor, Office No-25, <br />
            Garh Road, Meerut Pin Code- 250004
          </p>
        </div>

        <div>
          <h3 className="font-bold text-lg mb-4">
            Email : enquiry@travchap.com
          </h3>
          <p className="text-sm mb-2">Phone- 0121-4224817</p>
          <div className="flex space-x-4 mt-4 justify-center md:justify-start">
            <a href="#" className="hover:text-gray-300">
              <FaFacebookF />
            </a>
            <a href="#" className="hover:text-gray-300">
              <FaTwitter />
            </a>
            <a href="#" className="hover:text-gray-300">
              <FaYoutube />
            </a>
            <a href="#" className="hover:text-gray-300">
              <FaGoogle />
            </a>
            <a href="#" className="hover:text-gray-300">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-green-700 text-center py-4 text-sm">
        © {new Date().getFullYear()} All Rights Reserved
      </div>
    </footer>
  );
}

export default Footer;
